import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-96138bec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "fullscreen-modal__top-title" }
const _hoisted_4 = { class: "fullscreen-modal__title" }
const _hoisted_5 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = {
  key: 0,
  class: "person-counter__label"
}
const _hoisted_8 = {
  key: 1,
  class: "person-counter__label"
}
const _hoisted_9 = { class: "row gy-4 mt-md-5 mt-2" }
const _hoisted_10 = { class: "col-xl-5" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "ticket-configuration__small-title" }
const _hoisted_13 = { class: "ticket-configuration__small-title" }
const _hoisted_14 = { class: "col-xl-7" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "title-block__top-title" }
const _hoisted_17 = { class: "title-block__title js-toc__title h4 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_ProfilePersonConfiguration = _resolveComponent("ProfilePersonConfiguration")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_PriceGroupConfigurations = _resolveComponent("PriceGroupConfigurations")!
  const _component_EditModal = _resolveComponent("EditModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingSpinner, { loading: _ctx.isLoading }, null, 8, ["loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.translate('shop.configuration.choose-persons')), 1),
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
        (!_ctx.isPriceCalculator)
          ? (_openBlock(), _createBlock(_component_Breadcrumb, {
              key: 0,
              step: _ctx.step,
              onChangeStep: _ctx.onChangeStep,
              stepViews: _ctx.stepViews
            }, null, 8, ["step", "onChangeStep", "stepViews"]))
          : (_openBlock(), _createBlock(_component_Breadcrumb, {
              key: 1,
              step: _ctx.step,
              onChangeStep: _ctx.onChangeStep,
              stepViews: _ctx.stepViews,
              type: 'pricecalculator'
            }, null, 8, ["step", "onChangeStep", "stepViews"]))
      ]),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.translate('shop.configuration.persons')) + " ", 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPriceGroups, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-md person-count-wrapper",
                  key: item.value
                }, [
                  _createVNode(_Transition, { name: "fade" }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("span", {
                        class: "person-counter__count",
                        key: 'counter-' + _ctx.ticketConfigurations['priceGroups'][item.value]?.counter
                      }, _toDisplayString(_ctx.priceGroupCounter[item.value]), 1))
                    ]),
                    _: 2
                  }, 1024),
                  (_ctx.ticketConfigurations['priceGroups'][item.value]?.counter <= 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.label), 1))
                    : _createCommentVNode("", true),
                  (_ctx.ticketConfigurations['priceGroups'][item.value]?.counter >= 2)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.labelPlural), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_Transition, {
                key: 0,
                class: "card-body",
                name: "login-fade",
                appear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", { key: _ctx.isLoggedIn }, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.translate('shop.configuration.add-persons-from-profile')), 1),
                    _createVNode(_component_ProfilePersonConfiguration, {
                      ticketConfiguration: _ctx.ticketConfigurations,
                      profilePersons: _ctx.profilePersons,
                      onAddPerson: _ctx.onAddPerson,
                      onRemovePerson: _ctx.onRemovePerson,
                      selectedPriceConfiguration: _ctx.selectedPriceConfiguration,
                      selectedCurrency: _ctx.selectedCurrency
                    }, null, 8, ["ticketConfiguration", "profilePersons", "onAddPerson", "onRemovePerson", "selectedPriceConfiguration", "selectedCurrency"])
                  ]))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_Transition, {
                key: 1,
                class: "card-body",
                name: "login-fade",
                appear: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", { key: _ctx.isLoggedIn }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.translate('shop.configuration.add-persons-from-profile')), 1),
                    _createVNode(_component_LoginForm, {
                      ticketId: _ctx.ticketId,
                      onLoggedInData: _ctx.onLoggedInData
                    }, null, 8, ["ticketId", "onLoggedInData"])
                  ]))
                ]),
                _: 1
              }))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_PriceGroupConfigurations, {
          title: _ctx.translate('shop.configuration.add-persons-from-age-groups'),
          allPriceGroups: _ctx.allPriceGroups,
          selectedPriceConfiguration: _ctx.selectedPriceConfiguration,
          "ticket-configuration": _ctx.ticketConfigurations,
          selectedCurrency: _ctx.selectedCurrency,
          selectedDateStart: _ctx.selectedDateStart,
          selectedDateEnd: _ctx.selectedDateEnd,
          onChangePriceGroupCounter: _ctx.onChangePriceGroupCounter
        }, null, 8, ["title", "allPriceGroups", "selectedPriceConfiguration", "ticket-configuration", "selectedCurrency", "selectedDateStart", "selectedDateEnd", "onChangePriceGroupCounter"])
      ])
    ]),
    _createVNode(_component_EditModal, {
      show: _ctx.showOverlay,
      onClose: _ctx.closeOverlay
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h3", _hoisted_16, _toDisplayString(_ctx.modalTopTitle), 1),
          _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.modalTitle), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.modalContent), 1)
        ])
      ]),
      _: 1
    }, 8, ["show", "onClose"])
  ], 64))
}